import { get } from 'lodash';
import axios from 'axios';
import { push } from 'connected-react-router';

import { NETWORK } from '../../../framework/App/AppConstants';
import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';
import { APP_PEND_API } from '../../config/apiEndpoints';
import { PAGE_NAME } from '../../config/pageNames';
import { safeStringify } from '../../../shared-utilities/safeStringify';

export const getAppPendVerificationDetails = () => (dispatch, getState) => {
    const logPrefix = 'getAppPendVerificationDetails:';
    const { serverData = {} } = getState();
    const { _csrf = '', appPendData = {} } = serverData;
    return axios
        .request({
            url: APP_PEND_API,
            method: 'post',
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            }
        })
        .then((response) => {
            const verificationDetails = get(response, 'data.appPendVerifcationResponse.requiredDocumentsData.data.getVerificationDetails', {});
            capeLog && capeLog(`${logPrefix} response: verificationDetails: ${safeStringify(verificationDetails)}`);
            if (!verificationDetails.workflowStatus && !verificationDetails?.verificationDetails.length) {
                dispatch(push(PAGE_NAME.ERROR_PAGE));
            }
            dispatch(setServerData({
                appPendData: {
                    ...appPendData,
                    documentVerificationDetails: get(response, 'data.appPendVerifcationResponse')
                }
            }));
        })
        .catch(error => {
            capeLog && capeLog('response:error, appPendPageAction,' + (error && error.message));
            dispatch(push(PAGE_NAME.ERROR_PAGE));
        });
};
